import request from "@/utils/request";
// 设备状态管理
export function sbStateManage(params) {
  return request({
    url: "/system/bsinfo/sbStateManage",
    method: "post",
    data: params,
  });
}

// 卷标号管理与验证
export function jbhList(params) {
  return request({
    url: "/system/jbh/jbhList",
    method: "post",
    data: params,
  });
}
// 卷标号验证
export function addJbh(params) {
  return request({
    url: "/system/jbh/addJbh",
    method: "post",
    data: params,
  });
}
// 电子秤主题库列表
export function dzcList(params) {
  return request({
    url: "/system/dzc/dzcList",
    method: "post",
    data: params,
  });
}
// 协议详情
export function queryDzcByid(id) {
  return request({
    url: `/system/dzc/queryDzcByid/${id}`,
    method: "get",
  });
}

// 协议修改
export function updateDzcById(params) {
  return request({
    url: `/system/dzc/updateDzcById`,
    method: "post",
    data: params,
  });
}

// 新增设备
export function insertDzc(params) {
  return request({
    url: `/system/dzc/insertDzc`,
    method: "post",
    data: params,
  });
}

// 修改设备状态
export function updateSbInfoStateById(params) {
  return request({
    url: `/system/sbinfo/updateSbInfoStateById`,
    method: "post",
    data: params,
  });
}
// 删除设备（逻辑删除）
export function updateDeleteDzc(params) {
    return request({
        url: `/system/dzc/updateDeleteDzc`,
        method: "post",
        data: params,
    });
}
